import { ShelfSet } from '@/Engine/Wardrobe/ShelfSet';
import { wardrobeTemplates } from '@/Interfaces/common';
import { useUIOnlyStore } from '@/Store/storeUI';
import { $ } from '@/Engine/state';
import { useStoreData } from '@/Store/storeData';
import { convertItem } from '@/lib/createModule';
import { useConfigurationStore } from '@/Store/storeConfiguration';

export const getShelfAccessories = (name: string) => {
    const shelfSet = $.selectionBox?.target as ShelfSet;
    if (!shelfSet) {
        return null;
    }

    return useStoreData().items
        .filter((item) => item.name.includes(name))
        .filter((item) => shelfSet.color.includes(item.color.hex))
        .filter((item) => item.compatibilityDepth === shelfSet.compatibilityDepth);
};

export const addShelfAccessories = (side: 'left' | 'right' | 'center', name: string) => {

    const shelfSet = $.selectionBox?.target as ShelfSet;
    if (!shelfSet) {
        return;
    }
    const newTemplate = JSON.parse(JSON.stringify(shelfSet.templates)) as wardrobeTemplates;

    const shelfAccessories = getShelfAccessories(name);
    if (!shelfAccessories[0]) {
        console.warn('Не найден подходящая боковая панель с крючками');
        console.warn(shelfSet.compatibilityDepth, shelfSet.color);
        return;
    }

    const extraItemTemplate = convertItem(shelfAccessories[0]);

    if (side === 'left') {
        if (newTemplate.bracketLeftExtra && newTemplate.bracketLeftExtra.name === extraItemTemplate.name) {
            newTemplate.bracketLeftExtra = undefined;
        } else {
            newTemplate.bracketLeftExtra = extraItemTemplate;
        }
    }

    if (side === 'right') {
        if (newTemplate.bracketRightExtra && newTemplate.bracketRightExtra.name === extraItemTemplate.name) {
            newTemplate.bracketRightExtra = undefined;
        } else {
            newTemplate.bracketRightExtra = extraItemTemplate;
        }
    }

    if (side === 'center') {
        if (newTemplate.bracketCenterExtra && newTemplate.bracketCenterExtra.name === extraItemTemplate.name) {
            newTemplate.bracketCenterExtra = undefined;
        } else {
            newTemplate.bracketCenterExtra = extraItemTemplate;
        }
    }

    shelfSet.templates = newTemplate;
    shelfSet.updateModels(newTemplate);
    shelfSet.updatePartPosition();
    $.render();
    useConfigurationStore().addKit($.wardrobe.raw);
};

export const addSeparator = () => {
    const shelfSet = $.selectionBox?.target as ShelfSet;
    if (!shelfSet) {
        return;
    }

    const meshName = shelfSet.compatibilityDepth === '40' ? 'gpd_40_10' : 'gpd_30_10';
    const separatorItem = useStoreData().items.find(item => item.blender_name === meshName);

    if (!separatorItem) {
        console.warn(`Разделитель с мешем ${meshName} не найден`);
        return;
    }

    const newTemplate = JSON.parse(JSON.stringify(shelfSet.templates)) as wardrobeTemplates;
    if (!newTemplate.separators) {
        newTemplate.separators = [];
    }

    if (newTemplate.separators.length >= 5) {
        return;
    }

    newTemplate.separators.push(convertItem(separatorItem));
    shelfSet.templates = newTemplate;
    shelfSet.updateModels(newTemplate);
    shelfSet.updatePartPosition();
    $.render();
    useConfigurationStore().addKit($.wardrobe.raw);
};

export const removeSeparator = () => {
    const shelfSet = $.selectionBox?.target as ShelfSet;
    if (!shelfSet) {
        return;
    }

    const newTemplate = JSON.parse(JSON.stringify(shelfSet.templates)) as wardrobeTemplates;
    if (!newTemplate.separators || newTemplate.separators.length === 0) {
        return;
    }

    newTemplate.separators.pop();

    shelfSet.templates = newTemplate;
    shelfSet.updateModels(newTemplate);
    shelfSet.updatePartPosition();
    $.render();
    useConfigurationStore().addKit($.wardrobe.raw);
};

export const removeAllSeparators = () => {
    const shelves = useConfigurationStore().getShelves;
    let changed = false;

    shelves.forEach((shelf) => {
        if (shelf.templates.separators && shelf.templates.separators.length > 0) {
            const newTemplate = JSON.parse(JSON.stringify(shelf.templates)) as wardrobeTemplates;
            newTemplate.separators = [];

            // Находим соответствующий объект ShelfSet в сцене для обновления визуализации
            const shelfSet = $.wardrobe.shelves.find(s => s.uuid === shelf.uuid);
            if (shelfSet) {
                shelfSet.templates = newTemplate;
                shelfSet.updateModels(newTemplate);
                shelfSet.updatePartPosition();
            }

            // Обновляем данные в сторе
            useConfigurationStore().updateShelf({
                ...shelf,
                templates: newTemplate,
            });
            changed = true;
        }
    });

    if (changed) {
        $.render();
        useConfigurationStore().addKit($.wardrobe.raw);
    }
};

export const removeAllAccessoriesByBlenderName = (blenderName: string) => {
    const shelves = useConfigurationStore().getShelves;
    let changed = false;

    shelves.forEach((shelf) => {
        const newTemplate = JSON.parse(JSON.stringify(shelf.templates)) as wardrobeTemplates;
        let shelfChanged = false;
        
        if (newTemplate.bracketLeftExtra && newTemplate.bracketLeftExtra.name === blenderName) {
            newTemplate.bracketLeftExtra = undefined;
            shelfChanged = true;
        }
        if (newTemplate.bracketRightExtra && newTemplate.bracketRightExtra.name === blenderName) {
            newTemplate.bracketRightExtra = undefined;
            shelfChanged = true;
        }
        if (newTemplate.bracketCenterExtra && newTemplate.bracketCenterExtra.name === blenderName) {
            newTemplate.bracketCenterExtra = undefined;
            shelfChanged = true;
        }

        if (shelfChanged) {
            // Находим соответствующий объект ShelfSet в сцене для обновления визуализации
            const shelfSet = $.wardrobe.shelves.find(s => s.uuid === shelf.uuid);
            if (shelfSet) {
                shelfSet.templates = newTemplate;
                shelfSet.updateModels(newTemplate);
                shelfSet.updatePartPosition();
            }

            // Обновляем данные в сторе
            useConfigurationStore().updateShelf({
                ...shelf,
                templates: newTemplate,
            });
            changed = true;
        }
    });

    if (changed) {
        $.render();
        useConfigurationStore().addKit($.wardrobe.raw);
    }
};
